// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
   background-color: #f5f5f5;
   width: 600px;
   overflow-y: auto;
   overflow-x: hidden;
   max-height: inherit;
   min-height: auto;
}

.actions {
    height: 400px;
}

.error {
   font-size: 13px;
   color: #d32f2f;
}
.doclist-wrapper {
   margin-right: 2em;
}
.doc-header {
   background-color: #fff;
   height: 9px;
   border-bottom: 1px solid #eaeaea;
   margin-right: 2em;
   position: fixed;
   transition: border-color .2s, box-shadow .2s;
   z-index: 5;
}
.doc-header.shadow {
   border-color: #eaeaea;
   box-shadow: 0 4px 6px -2px rgba(0,0,0,.04);
}
.doclist {
   list-style: none;
   margin: 0;
   padding: 5px 10px;
}
.doclist a {
   cursor: pointer;
}
.doclist a.selectedPath {
   color: #00bed6;
}
.doclist i {
   width: 20px;
   height: 20px;
   line-height: 20px;
   text-align: center;
}
.file-avatar-icon img {
   display: block;
   width: 32px;
   height: 32px;
   object-fit: contain;
}
.file-avatar-icon img.cover {
   object-fit: cover;
}
.file-avatar img {
   display: block;
   margin: 10px;
   width: 32px;
   height: 32px;
   object-fit: contain;
}
.file-avatar img.cover {
   object-fit: cover;
}
.file-filename {
   padding: 6px 0;
   max-width: 50%;
}
.file-filename a {
   cursor: pointer;
}
.selected .file-username a, .selected .file-username span {
   color: #1a5976;
}
.mat-dialog-content {
   overflow: hidden;
}
.mat-dialog-title {
   font-size: 18px;
   word-break: break-all;
   width: 600px;
   font-family: inherit;
}
i:not(.caret):before {
   vertical-align: middle;
}
i.caret {
   cursor: default;
   font-size: inherit;
   left: 1px;
   transition: transform .4s;
}
.expanded {
   transform: rotate(90deg);
}
.doclist a.denied {
   cursor: default;
   color: #a7a6a6;
   text-decoration: none;
}
.denied img {
   filter: grayscale(100%);
   opacity: .8;
}
img {
   width: 20px;
   height: 20px;
   vertical-align: text-top;
}
app-folders,
app-one-drive-folders,
app-google-drive-folders,app-dropbox-folders{
   display: block;
   margin-left: 18px;
}
::ng-deep .mat-button:hover .mat-button-focus-overlay{
   opacity: 0.04 !important;
}

ul {
   list-style-type: none;
   margin: 0px;
   padding: 6px 10px 10px;
 }

.loading-container {
   overflow: hidden;
   width:600px;
   height: 400px!important;
}


.container {
   overflow: hidden;
}
.folders {
   list-style: none;
   margin: 0;
   padding: 0;
}
li {
   margin-top: 8px;
   position: relative;
   white-space: nowrap;
}
a {
   color: #666;
   cursor: pointer;
   display: inline-block;
   line-height: 20px;
   margin-left: 45px;
   padding-right: 5px;
   position: relative;
   word-break: break-all;
}
a:hover {
   color: #ffa726;
}
i {
   display: block;
   line-height: 20px;
   width: 20px;
   height: 20px;
   text-align: center;
   transition: transform .3s;
   position: absolute;
   top: 0;
   left: 0;
}
i.fa-spinner {
   left: -1px;
}
img {
   display: block;
   width: 20px;
   height: 20px;
   position: absolute;
   top: 0;
   left: -25px;
}
.expanded {
   transform: rotate(90deg);
}
.error {
   margin-left: 8px;
   margin-top: 5px;
}

a.selectedPath {
   color: #00bed6;
}
a.denied {
   cursor: default;
   color: #a7a6a6;
   text-decoration: none;
}
.denied img {
   filter: grayscale(100%);
   opacity: .8;
}
.cannot{
   color: #a7a6a6;
   cursor:default;
   text-decoration:none;
}
.cannot:hover{
   color: #a7a6a6!important;
   text-decoration:none;
}
.marginFolder{
   margin-left:30px!important;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/export-task-dialog/export-task-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;GACzB,YAAY;GACZ,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;GACnB,gBAAgB;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;GACG,eAAe;GACf,cAAc;AACjB;AACA;GACG,iBAAiB;AACpB;AACA;GACG,sBAAsB;GACtB,WAAW;GACX,gCAAgC;GAChC,iBAAiB;GACjB,eAAe;GACf,4CAA4C;GAC5C,UAAU;AACb;AACA;GACG,qBAAqB;GACrB,0CAA0C;AAC7C;AACA;GACG,gBAAgB;GAChB,SAAS;GACT,iBAAiB;AACpB;AACA;GACG,eAAe;AAClB;AACA;GACG,cAAc;AACjB;AACA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,kBAAkB;AACrB;AACA;GACG,cAAc;GACd,WAAW;GACX,YAAY;GACZ,mBAAmB;AACtB;AACA;GACG,iBAAiB;AACpB;AACA;GACG,cAAc;GACd,YAAY;GACZ,WAAW;GACX,YAAY;GACZ,mBAAmB;AACtB;AACA;GACG,iBAAiB;AACpB;AACA;GACG,cAAc;GACd,cAAc;AACjB;AACA;GACG,eAAe;AAClB;AACA;GACG,cAAc;AACjB;AACA;GACG,gBAAgB;AACnB;AACA;GACG,eAAe;GACf,qBAAqB;GACrB,YAAY;GACZ,oBAAoB;AACvB;AACA;GACG,sBAAsB;AACzB;AACA;GACG,eAAe;GACf,kBAAkB;GAClB,SAAS;GACT,yBAAyB;AAC5B;AACA;GACG,wBAAwB;AAC3B;AACA;GACG,eAAe;GACf,cAAc;GACd,qBAAqB;AACxB;AACA;GACG,uBAAuB;GACvB,WAAW;AACd;AACA;GACG,WAAW;GACX,YAAY;GACZ,wBAAwB;AAC3B;AACA;;;GAGG,cAAc;GACd,iBAAiB;AACpB;AACA;GACG,wBAAwB;AAC3B;;AAEA;GACG,qBAAqB;GACrB,WAAW;GACX,sBAAsB;CACxB;;AAED;GACG,gBAAgB;GAChB,WAAW;GACX,uBAAuB;AAC1B;;;AAGA;GACG,gBAAgB;AACnB;AACA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,eAAe;GACf,kBAAkB;GAClB,mBAAmB;AACtB;AACA;GACG,WAAW;GACX,eAAe;GACf,qBAAqB;GACrB,iBAAiB;GACjB,iBAAiB;GACjB,kBAAkB;GAClB,kBAAkB;GAClB,qBAAqB;AACxB;AACA;GACG,cAAc;AACjB;AACA;GACG,cAAc;GACd,iBAAiB;GACjB,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,yBAAyB;GACzB,kBAAkB;GAClB,MAAM;GACN,OAAO;AACV;AACA;GACG,UAAU;AACb;AACA;GACG,cAAc;GACd,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,MAAM;GACN,WAAW;AACd;AACA;GACG,wBAAwB;AAC3B;AACA;GACG,gBAAgB;GAChB,eAAe;AAClB;;AAEA;GACG,cAAc;AACjB;AACA;GACG,eAAe;GACf,cAAc;GACd,qBAAqB;AACxB;AACA;GACG,uBAAuB;GACvB,WAAW;AACd;AACA;GACG,cAAc;GACd,cAAc;GACd,oBAAoB;AACvB;AACA;GACG,wBAAwB;GACxB,oBAAoB;AACvB;AACA;GACG,0BAA0B;AAC7B","sourcesContent":[".main {\n   background-color: #f5f5f5;\n   width: 600px;\n   overflow-y: auto;\n   overflow-x: hidden;\n   max-height: inherit;\n   min-height: auto;\n}\n\n.actions {\n    height: 400px;\n}\n\n.error {\n   font-size: 13px;\n   color: #d32f2f;\n}\n.doclist-wrapper {\n   margin-right: 2em;\n}\n.doc-header {\n   background-color: #fff;\n   height: 9px;\n   border-bottom: 1px solid #eaeaea;\n   margin-right: 2em;\n   position: fixed;\n   transition: border-color .2s, box-shadow .2s;\n   z-index: 5;\n}\n.doc-header.shadow {\n   border-color: #eaeaea;\n   box-shadow: 0 4px 6px -2px rgba(0,0,0,.04);\n}\n.doclist {\n   list-style: none;\n   margin: 0;\n   padding: 5px 10px;\n}\n.doclist a {\n   cursor: pointer;\n}\n.doclist a.selectedPath {\n   color: #00bed6;\n}\n.doclist i {\n   width: 20px;\n   height: 20px;\n   line-height: 20px;\n   text-align: center;\n}\n.file-avatar-icon img {\n   display: block;\n   width: 32px;\n   height: 32px;\n   object-fit: contain;\n}\n.file-avatar-icon img.cover {\n   object-fit: cover;\n}\n.file-avatar img {\n   display: block;\n   margin: 10px;\n   width: 32px;\n   height: 32px;\n   object-fit: contain;\n}\n.file-avatar img.cover {\n   object-fit: cover;\n}\n.file-filename {\n   padding: 6px 0;\n   max-width: 50%;\n}\n.file-filename a {\n   cursor: pointer;\n}\n.selected .file-username a, .selected .file-username span {\n   color: #1a5976;\n}\n.mat-dialog-content {\n   overflow: hidden;\n}\n.mat-dialog-title {\n   font-size: 18px;\n   word-break: break-all;\n   width: 600px;\n   font-family: inherit;\n}\ni:not(.caret):before {\n   vertical-align: middle;\n}\ni.caret {\n   cursor: default;\n   font-size: inherit;\n   left: 1px;\n   transition: transform .4s;\n}\n.expanded {\n   transform: rotate(90deg);\n}\n.doclist a.denied {\n   cursor: default;\n   color: #a7a6a6;\n   text-decoration: none;\n}\n.denied img {\n   filter: grayscale(100%);\n   opacity: .8;\n}\nimg {\n   width: 20px;\n   height: 20px;\n   vertical-align: text-top;\n}\napp-folders,\napp-one-drive-folders,\napp-google-drive-folders,app-dropbox-folders{\n   display: block;\n   margin-left: 18px;\n}\n::ng-deep .mat-button:hover .mat-button-focus-overlay{\n   opacity: 0.04 !important;\n}\n\nul {\n   list-style-type: none;\n   margin: 0px;\n   padding: 6px 10px 10px;\n }\n\n.loading-container {\n   overflow: hidden;\n   width:600px;\n   height: 400px!important;\n}\n\n\n.container {\n   overflow: hidden;\n}\n.folders {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\nli {\n   margin-top: 8px;\n   position: relative;\n   white-space: nowrap;\n}\na {\n   color: #666;\n   cursor: pointer;\n   display: inline-block;\n   line-height: 20px;\n   margin-left: 45px;\n   padding-right: 5px;\n   position: relative;\n   word-break: break-all;\n}\na:hover {\n   color: #ffa726;\n}\ni {\n   display: block;\n   line-height: 20px;\n   width: 20px;\n   height: 20px;\n   text-align: center;\n   transition: transform .3s;\n   position: absolute;\n   top: 0;\n   left: 0;\n}\ni.fa-spinner {\n   left: -1px;\n}\nimg {\n   display: block;\n   width: 20px;\n   height: 20px;\n   position: absolute;\n   top: 0;\n   left: -25px;\n}\n.expanded {\n   transform: rotate(90deg);\n}\n.error {\n   margin-left: 8px;\n   margin-top: 5px;\n}\n\na.selectedPath {\n   color: #00bed6;\n}\na.denied {\n   cursor: default;\n   color: #a7a6a6;\n   text-decoration: none;\n}\n.denied img {\n   filter: grayscale(100%);\n   opacity: .8;\n}\n.cannot{\n   color: #a7a6a6;\n   cursor:default;\n   text-decoration:none;\n}\n.cannot:hover{\n   color: #a7a6a6!important;\n   text-decoration:none;\n}\n.marginFolder{\n   margin-left:30px!important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
